import { render, staticRenderFns } from "./Resumen.vue?vue&type=template&id=40cea6db"
import script from "./Resumen.vue?vue&type=script&lang=ts"
export * from "./Resumen.vue?vue&type=script&lang=ts"
import style0 from "./Resumen.vue?vue&type=style&index=0&id=40cea6db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports